import {
    ModuleWithProviders,
    NgModule,
} from '@angular/core';
import {
    PageCategory,
    PageScope,
    providePageMeta,
} from '@app/router';

@NgModule()
export class SharedMetaModule {
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: SharedMetaModule,
            providers: [
                providePageMeta({
                    title: 'Access Denied',
                    translationKey: 'page_not_found',
                    routerLink: '/restricted-access',
                    isWhitelisted: true,
                    category: PageCategory.All,
                    scope: PageScope.Global,
                }),
            ],
        };
    }
}
